setUserAccountCancelSubscriptionConfirmProcessing